import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

export const ImportData = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/applicant/api/applicant-update/bulk-insert/`,
      data,
      getHeaders()
    );
    console.log("ImportData", response);

    return response.data;
  } catch (error) {
    console.error("Error adding shortlisting entry:", error);
    throw error;
  }
};

export const getApplicationRecords = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/applicant/api/applicant-update/get-record/`,
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching application records:", error);
    throw error;
  }
};

// Get available fields (we'll add this function)
export const getAvailableFields = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/applicant/api/applicant-update/get-fields/`,
      getHeaders()
    );
    return response.data.fields;
  } catch (error) {
    console.error("Error fetching available fields:", error);
    // Return default fields as fallback
    return [
      "sr_no",
      "student_name",
      "university",
      "updates",
      "course_name",
      "current_status",
      "offer_received_rejected",
      "location",
      "partner",
      "app_fee",
      "status",
      "dynamic_fields",
    ];
  }
};

// Add column (using existing function)
export const addApplicationColumn = async (columnName, defaultValue = "") => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/applicant/api/applicant-update/add-column/`,
      {
        column_name: columnName,
        default_value: defaultValue,
      },
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error adding application column:", error);
    throw error;
  }
};

// Remove column
export const removeApplicationColumn = async (columnName) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/applicant/api/applicant-update/remove-column/`,
      {
        column_name: columnName,
      },
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error removing application column:", error);
    throw error;
  }
};

// Add row
export const addApplicationRow = async (rowData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/applicant/api/applicant-update/bulk-insert/`,
      {
        records: [rowData],
      },
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error adding application row:", error);
    throw error;
  }
};

// Update row
export const updateApplicationRow = async (rowData) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/applicant/api/applicant-update/bulk-update/`,
      {
        records: [rowData],
      },
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error updating application row:", error);
    throw error;
  }
};

// Delete row
export const deleteApplicationRow = async (srNo) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/applicant/api/applicant-update/bulk-delete/`,
      {
        data: { sr_nos: [srNo] },
        ...getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting application row:", error);
    throw error;
  }
};

// Bulk operations for better performance
export const bulkUpdateApplicationRows = async (data) => {
  try {
    // The data structure is already correct from handleSaveChanges
    // We're sending exactly what the backend expects

    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/applicant/api/applicant-update/bulk-update/`,
      data,
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error bulk updating application rows:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
    }
    throw error;
  }
};
export const bulkInsertApplicationRows = async (records) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/applicant/api/applicant-update/bulk-insert/`,
      records,
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error bulk inserting application rows:", error);
    throw error;
  }
};

export const bulkDeleteApplicationRows = async (ids) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/applicant/api/applicant-update/bulk-delete/`,
      {
        data: { sr_no: ids }, // Use sr_no (singular) as shown in your backend code
        ...getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error bulk deleting application rows:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
    }
    throw error;
  }
};

export const updateSingleRecord = async (record) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/applicant/api/applicant-update/${record.id}/`,
      record,
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating record ${record.id}:`, error);
    throw error;
  }
};

export const getFinalizedApplication = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/student/finalized-students/`,
    getHeaders()
  );

  return response.data.students;
};
